module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "ded",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_vm._v("For Brandon and Holly Robison,"), _c('br'), _vm._v("my nephew and niece, who have"), _c('br'), _vm._v("starred in some of my earlier works,"), _c('br'), _vm._v("including such classics as "), _c('i', [_vm._v("A Very"), _c('br'), _vm._v("Zombie Christmas")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_vm._v("Special thanks to April Murray for"), _c('br'), _vm._v("her insightful review to ensure a"), _c('br'), _vm._v("respectful portrayal of the"), _c('br'), _vm._v("Maasai people")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36bc0a81","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ded.vue
// module id = 69
// module chunks = 0